import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../../api";
import { UserOrgRole } from "../../../generated/core-api";

/**
 * Hook for removing a role from a user in an organization
 */
export function useRemoveOrgRole() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userOrgRole: UserOrgRole) => {
      return await api.removeOrgRole(userOrgRole);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["orgs", variables.org_category, variables.org_id, "members"],
      });
      queryClient.invalidateQueries({
        queryKey: ["listOrgRolesByUser", variables.user_id],
      });
    },
  });
}
